import { blogData } from "../../data/blogData";
import "./blog.css";

export function Blog() {
    return (
        <main className="bg-secondary text-white py-14 px-20 text-center">
            <h1 className="text-4xl font-bold">My blogs</h1>
            <div className="flex flex-wrap gap-10 py-14">
                {blogData.map((blog) => (
                    <div
                        className="basis-0 flex-grow max-w-[400px] bg-primary pb-5 "
                        key={blog.displayName}
                    >
                        <div className="flex flex-col h-full gap-5 py-5 px-5">
                            <p className="text-2xl font-semibold">
                                {blog.displayName}
                            </p>
                            <p className="mt-auto">{blog.description}</p>
                            <a
                                href={blog.url}
                                className="px-7 py-3 bg-secondary mt-auto hover:opacity-80 font-semibold rounded-3xl"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Read more
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </main>
    );
}
